module.exports = __webpack_public_path__ + "static/fonts/manrope-extrabold.f7cabd52.woff";